import { render, staticRenderFns } from "./dc-vizlet-dyn.vue?vue&type=template&id=3f46f144&scoped=true&"
import script from "./dc-vizlet-dyn.vue?vue&type=script&lang=js&"
export * from "./dc-vizlet-dyn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f46f144",
  null
  
)

export default component.exports